import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/kbstar/markCircle.png'
import _imports_1 from '../../assets/kbstar/qr.png'


const _withScopeId = n => (_pushScopeId("data-v-0fe9024c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_section" }
const _hoisted_2 = ["data-url"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "markCircle"
}, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "benefit_section" }
const _hoisted_5 = ["data-url"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p class=\"title\" data-v-0fe9024c>튜터링 수강권</p><p class=\"desc\" data-v-0fe9024c>최대 59% 할인!</p><div class=\"benefit_card\" data-v-0fe9024c><div class=\"benefit_card_label\" data-v-0fe9024c>혜택 1</div><div class=\"benefit_card_desc\" data-v-0fe9024c> 업계최저가 보장! <br data-v-0fe9024c> 튜터링 상설특가제 <b data-v-0fe9024c>최대 51% 할인</b></div></div><div class=\"benefit_card\" data-v-0fe9024c><div class=\"benefit_card_label\" data-v-0fe9024c>혜택 2</div><div class=\"benefit_card_desc\" data-v-0fe9024c> 최대 51% 할인가에 KB 제휴쿠폰 <br data-v-0fe9024c><b data-v-0fe9024c>20% 추가 할인!</b></div></div><div class=\"benefit_card\" data-v-0fe9024c><div class=\"benefit_card_label\" data-v-0fe9024c>혜택 3</div><div class=\"benefit_card_desc\" data-v-0fe9024c> 1:1회화 수업 <br data-v-0fe9024c><b data-v-0fe9024c>2회 추가 증정</b> (수량 한정) </div></div>", 5)
const _hoisted_11 = { class: "event_section" }
const _hoisted_12 = ["data-url"]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"card\" data-v-0fe9024c><div class=\"title\" data-v-0fe9024c>이벤트 기간</div><div class=\"desc\" data-v-0fe9024c>2023.4.10(월) ~ 4.30(일)</div></div><div class=\"card\" data-v-0fe9024c><div class=\"title\" data-v-0fe9024c>이벤트 대상</div><div class=\"desc\" data-v-0fe9024c>KB스타뱅킹 로그인한 고객 누구나</div></div><div class=\"card\" data-v-0fe9024c><div class=\"title\" data-v-0fe9024c>참여 방법</div><div class=\"desc\" data-v-0fe9024c> 1. KB 스타뱅킹 APP의 ‘이벤트&#39; 메뉴 선택 <br data-v-0fe9024c> 2. 튜터링 이벤트의 ‘응모하기&#39; 버튼 클릭 <br data-v-0fe9024c> 3. KB스타뱅킹 알림(Push)동의 </div><div class=\"desc_small\" style=\"margin-left:15px;\" data-v-0fe9024c>*기존 알림 동의 고객 응모 가능</div></div><div class=\"card\" data-v-0fe9024c><div class=\"title\" data-v-0fe9024c>참여 혜택</div><div class=\"desc\" data-v-0fe9024c>열공 응원 쿠폰 2종</div><div class=\"desc_small\" data-v-0fe9024c>*쿠폰은 매주 수요일 KB국민은행에 등록된 연락처로 발송될 예정입니다.</div></div>", 4)
const _hoisted_17 = { class: "coupon" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "[응모 시 100%] 20% 할인 쿠폰 (최대 20만원)", -1 /* HOISTED */))
const _hoisted_19 = ["data-url"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "[주차별 1만명 한정] 3만원 상당 무료체험권", -1 /* HOISTED */))
const _hoisted_21 = ["data-url"]
const _hoisted_22 = {
  key: 0,
  class: "qr"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" *PC로 접속하신 경우 아래 QR코드를 통해 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" KB스타뱅킹 앱 다운로드 후 쿠폰을 다운받아보세요. ")
], -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<section class=\"notice_section\" data-v-0fe9024c><div class=\"container\" data-v-0fe9024c><p class=\"title\" data-v-0fe9024c>[쿠폰 유의사항]</p><ul data-v-0fe9024c><li class=\"list__item\" data-v-0fe9024c> 할인 쿠폰 및 무료 체험권은 매주 수요일 KB국민은행에 등록된 연락처로 발송될 예정입니다. </li><li class=\"list__item\" data-v-0fe9024c> 할인 쿠폰 및 무료 체험권은 튜터링 앱 &gt; 마이 튜터링 &gt; 나의 쿠폰 메뉴에서 등록 후 사용 가능합니다. </li><li class=\"list__item\" data-v-0fe9024c> 할인 쿠폰 및 무료체험권 2023년 5월 7일까지 등록 가능하며, 등록 후 7일 이내 사용 가능합니다. </li><li class=\"list__item\" data-v-0fe9024c>무료체험권은 ‘Global 튜터 7일 20분 2회 수강권’ 으로 제공됩니다.</li><li class=\"list__item\" data-v-0fe9024c> 할인쿠폰은 1개월 정기 결제 수강권 결제 시 사용할 수 없으며, 분할 사용 및 타 쿠폰과 중복사용이 불가합니다. </li><li class=\"list__item\" data-v-0fe9024c><u data-v-0fe9024c>쿠폰 사용 관련 문의</u> 는 튜터링 App &gt; 마이튜터링 &gt; 이용안내 &gt; 고객센터로 문의 바랍니다. </li><li class=\"list__item\" data-v-0fe9024c><u data-v-0fe9024c>쿠폰 발송 관련 문의</u> 는 KB국민은행 고객센터(☎1588-9999)로 문의하시기 바랍니다. </li></ul><p class=\"title\" data-v-0fe9024c>[이벤트 유의사항]</p><ul data-v-0fe9024c><li class=\"list__item\" data-v-0fe9024c> 본 이벤트는 KB스타뱅킹 App(최종 업데이트 버전)의 이벤트 페이지에서만 응모가 가능합니다. </li><li class=\"list__item\" data-v-0fe9024c> 쿠폰 발송일 기준 KB스타뱅킹 알림(Push) 및 ‘혜택알림 &gt; 취향저격혜택’ 미동의 고객님은 쿠폰발송 대상에서 제외됩니다. </li><li class=\"list__item\" data-v-0fe9024c> 본 이벤트 응모 및 튜터링 제휴쿠폰 발급(사용)은 KB스타뱅킹 고객 대상 1인 1회만 가능합니다. (쿠폰 재발급/재사용 불가) </li><li class=\"list__item\" data-v-0fe9024c>튜터링 제휴쿠폰은 KB국민은행에 등록된 고객정보상 연락처를 통해서 개별 발송됩니다.</li><li class=\"list__item\" data-v-0fe9024c> 본 이벤트는 KB국민은행 혹은 튜터링 내부 사정에 따라 변경 또는 중단될 수 있으며, 이벤트 경품은 사정상 동일 금액대의 다른 상품으로 변경될 수 있습니다. </li><li class=\"list__item\" data-v-0fe9024c> 이벤트의 기타 자세한 내용은 KB국민은행 고객센터(☎1588-9999)로 문의하시거나 KB국민은행 홈페이지( <u data-v-0fe9024c>www.kbstar.com</u> )를 참조하시기 바랍니다. </li></ul></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNav = _resolveComponent("AppNav")!
  const _directive_img_lazy_loading = _resolveDirective("img-lazy-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" app nav "),
    ($options.appView)
      ? (_openBlock(), _createBlock(_component_AppNav, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("튜터링 X KB스타뱅킹")
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "promotion",
      style: _normalizeStyle({ 'padding-top': $options.appPadding })
    }, [
      _createElementVNode("section", _hoisted_1, [
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.img_kbp_01,
          class: "img_kbp_01",
          alt: "img_kbp_01"
        }, null, 8 /* PROPS */, _hoisted_2), [
          [_directive_img_lazy_loading]
        ]),
        _hoisted_3
      ]),
      _createElementVNode("section", _hoisted_4, [
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.img_kbp_02,
          class: "img_kbp_02",
          alt: "img_kbp_02"
        }, null, 8 /* PROPS */, _hoisted_5), [
          [_directive_img_lazy_loading]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("section", _hoisted_11, [
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.img_kbp_03,
          class: "img_kbp_03",
          alt: "img_kbp_03"
        }, null, 8 /* PROPS */, _hoisted_12), [
          [_directive_img_lazy_loading]
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.img_kbp_04,
            class: "img_kbp_04",
            alt: "img_kbp_04"
          }, null, 8 /* PROPS */, _hoisted_19), [
            [_directive_img_lazy_loading]
          ]),
          _hoisted_20,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.img_kbp_05,
            class: "img_kbp_05",
            alt: "img_kbp_05"
          }, null, 8 /* PROPS */, _hoisted_21), [
            [_directive_img_lazy_loading]
          ]),
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.downloadCoupon()))
          }, "제휴 쿠폰 받기")
        ]),
        (!$options.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" 하단 유의 사항  "),
      _hoisted_26
    ], 4 /* STYLE */)
  ], 64 /* STABLE_FRAGMENT */))
}